import React from 'react';
import { ChevronDown } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from '../ui/accordion';

export default function FaqAccordion({ items }) {
  return (
    <Accordion type="single" collapsible className="w-full">
      {items.map((it, i) => (
        <AccordionItem key={i} value={`item-${i}`} className="border-b border-slate-200">
          <AccordionTrigger className="text-left hover:no-underline group py-5">
            <span className="text-base lg:text-lg font-semibold text-slate-900 group-hover:text-emerald-700 pr-4">{it.q}</span>
          </AccordionTrigger>
          <AccordionContent className="text-slate-600 text-sm leading-relaxed pb-5">
            {it.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
